import z from 'zod'

const millsheetSortConfigSchema = z.object({
  // 「メーカー」「規格」「形状」の並び替え順をカスタマイズ設定できる
  manufacturerName: z.string().array().nullish(),
  steelType: z.string().array().nullish(),
  sectionType: z.string().array().nullish(),
})

type MillsheetSortConfig = z.infer<typeof millsheetSortConfigSchema>

type ExtendedMillsheet = {
  //   - 製造会社名
  // - 規格
  // - 形状
  // - 証明書番号
  // - 工区

  manufacturerName: string
  // steelType: string
  // sectionType: string
  no: string
  constructionArea: string
  [key: string]: unknown
}

type Value = string | null | number
export function sortMillsheets<Item extends ExtendedMillsheet>(
  items: Item[],
  sortConfig: MillsheetSortConfig,
  sortKeys: string[],
): Item[] {
  // 汎用的に使えるようにするため、Record型のItemを、keysでソートする
  return [...items].sort((a, b) => {
    for (const sortKey of sortKeys) {
      const aValue = a[sortKey] ?? ''
      const bValue = b[sortKey] ?? ''
      if (aValue !== bValue) {
        if (typeof aValue === 'string' && typeof bValue === 'string') {
          return compareMillsheetItemValueByConfig(aValue, bValue, sortConfig, sortKey)
        }
        if (typeof aValue === 'number' && typeof bValue === 'number') {
          return aValue - bValue
        }
        if (aValue === null && bValue === null) {
          return 0
        }
      }
    }
    return 0
  })
}

function compareMillsheetItemValueByConfig(
  aValue: Value,
  bValue: Value,
  sortConfig: MillsheetSortConfig,
  sortKey: string,
) {
  const sortConfigItem = sortConfig[sortKey as keyof MillsheetSortConfig] ?? []
  if (sortConfigItem.length > 0 && typeof aValue === 'string' && typeof bValue === 'string') {
    const _aIndex = sortConfigItem.indexOf(aValue)
    const _bIndex = sortConfigItem.indexOf(bValue)
    // 含まれていない値は、最後扱いにする
    const aIndex = _aIndex !== -1 ? _aIndex : sortConfigItem.length
    const bIndex = _bIndex !== -1 ? _bIndex : sortConfigItem.length
    return aIndex - bIndex
  }

  if (typeof aValue === 'number' && typeof bValue === 'number') {
    return aValue - bValue
  }

  if (aValue === null && bValue === null) {
    return 0
  }
  if (aValue === null) {
    return 1
  }
  if (bValue === null) {
    return -1
  }

  if (typeof aValue === 'string' && typeof bValue === 'string') {
    return aValue.localeCompare(bValue, 'ja', { numeric: true, sensitivity: 'base' })
  }

  return 0
}
